module.exports = __webpack_public_path__ + "static/img/iosewm.d1bfce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/iosewm.png
// module id = 266
// module chunks = 1